<template>
  <section id="testimonials" class="Testimonials">
    <div class="container">
      <h2>Testimonials</h2>
      <Carousel :items="1" :loop="true" :nav="false" :autoplay="true">
        <Testimonial
          quote="I have used David's wonderful service and expertise for many years and am happy to wholeheartedly recommend him. My clients also all tell me what a meticulous job he does and what a friendly manner he has. He's a pleasure to work with."
          name="IRVING LAFFNER"
          company="ART CONSULTANT"
        />
        <Testimonial
          quote="I have been extremely happy with the picture hanging service David has provided me with over the years. He is such a pleasure to work with and so reliable. I highly recommend him. His precise workmanship and friendly nature are a perfect combination. He will always go above and beyond on all jobs, making sure everything is perfect."
          name="CHLOE PLANINSEK"
          company="PLANINSEK ART"
        />
        <Testimonial
          quote="I have utilized David's services several times to hang my art works. His approach is very professional as he considers every detail, with a result that is meticulous in its execution."
          name="CHARLES JUSTIN"
          company="SJB ARCHITECTS"
        />
      </Carousel>
    </div>
  </section>
</template>
<script>
import Carousel from 'vue-owl-carousel'
import Testimonial from '../components/Testimonial'

export default {
  name: 'Testimonials',
  components: {
    Carousel,
    Testimonial
  },
  computed: {
  },
  mounted () {
  },
  data () {
    return {
    };
  }
};
</script>
<style lang='scss' scoped>
@import '../scss/colors.scss';

  .Testimonials {
    height: 600px;
    padding: 60px 0;
    background-image: url('../assets/images/image-bg-5.jpg');
    background-size: cover;
    background-position: center center;

    h2 {
      text-align: center;
      color: $white;
    }

    .Testimonial {
        max-width: 500px;
        margin: 0 auto;
    }
  }
</style>
